/*
  COREEX testimonials
  - Swiper slider with fractional slidesPerView (separate desktop/mobile values),
    prev/next arrows and clickable dots.
  - Video cards: ONE play button visible at a time. Before the first play it is
    the big centre button; after that the card gets .is-played and the small
    corner button takes over as a play/pause toggle. Starting one video pauses
    every other one in the section.

  Focal bundles Flickity, not Swiper, so window.Swiper is always absent and the
  CDN loader below runs. The two libraries share no globals or class names.
*/
(function () {
  'use strict';

  var CDN_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
  var CDN_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function ensureSwiper(cb) {
    if (window.Swiper) return cb();

    if (!document.getElementById('swiper-cdn-css')) {
      var link = document.createElement('link');
      link.id = 'swiper-cdn-css';
      link.rel = 'stylesheet';
      link.href = CDN_CSS;
      document.head.appendChild(link);
    }

    var existing = document.getElementById('swiper-cdn-js');
    if (existing) {
      existing.addEventListener('load', cb);
      return;
    }

    var s = document.createElement('script');
    s.id = 'swiper-cdn-js';
    s.src = CDN_JS;
    s.addEventListener('load', cb);
    document.head.appendChild(s);
  }

  function setupVideos(section) {
    var cards = section.querySelectorAll('.ct-card--video');
    var videos = [];

    for (var i = 0; i < cards.length; i++) {
      (function (card) {
        var video = card.querySelector('video');
        if (!video) return;
        videos.push(video);

        var centerBtn = card.querySelector('.ct-card__play--center');
        var cornerBtn = card.querySelector('.ct-card__play--corner');

        function play() {
          for (var j = 0; j < videos.length; j++) {
            if (videos[j] !== video) videos[j].pause();
          }
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        }

        // The centre button only ever starts playback; the corner button then
        // takes over as the toggle.
        if (centerBtn) {
          centerBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            play();
          });
        }

        if (cornerBtn) {
          cornerBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (video.paused) play();
            else video.pause();
          });
        }

        // .is-played is added once and never removed — the centre button is
        // retired for good after the first play. .is-playing tracks the live
        // state and drives the corner button's play/pause glyph in CSS.
        video.addEventListener('play', function () {
          card.classList.add('is-played');
          card.classList.add('is-playing');
          if (cornerBtn) {
            cornerBtn.setAttribute('aria-label', cornerBtn.getAttribute('data-label-pause') || 'Pause');
          }
        });

        video.addEventListener('pause', function () {
          card.classList.remove('is-playing');
          if (cornerBtn) {
            cornerBtn.setAttribute('aria-label', cornerBtn.getAttribute('data-label-play') || 'Play');
          }
        });

        video.addEventListener('ended', function () {
          card.classList.remove('is-playing');
          video.currentTime = 0;
        });
      })(cards[i]);
    }

    return videos;
  }

  function initSection(section) {
    if (!section || section.__ctInit) return;
    section.__ctInit = true;

    var slider = section.querySelector('.coreex-testimonials__slider');
    if (!slider) return;

    var slideCount = slider.querySelectorAll('.swiper-slide').length;
    if (slideCount === 0) return;

    var dSPV = parseFloat(section.getAttribute('data-spv-desktop')) || 3;
    var mSPV = parseFloat(section.getAttribute('data-spv-mobile')) || 1.2;
    // Swiper's base config is the MOBILE state; the 1000px breakpoint below
    // overrides it for desktop. So the mobile gap is the base value.
    var gap = parseInt(section.getAttribute('data-gap'), 10) || 16;
    var gapMobile = parseInt(section.getAttribute('data-gap-mobile'), 10);
    if (isNaN(gapMobile)) gapMobile = Math.round(gap / 1.5);
    var autoplayOn = section.getAttribute('data-autoplay') === 'true';
    var delay = (parseFloat(section.getAttribute('data-autoplay-speed')) || 5) * 1000;

    var videos = setupVideos(section);

    function pauseAll() {
      for (var i = 0; i < videos.length; i++) videos[i].pause();
    }

    var dots = section.querySelector('.coreex-testimonials__dots');
    var prev = section.querySelector('.coreex-testimonials__arrow--prev');
    var next = section.querySelector('.coreex-testimonials__arrow--next');

    ensureSwiper(function () {
      section.__ctSwiper = new Swiper(slider, {
        slidesPerView: mSPV,
        spaceBetween: gapMobile,
        grabCursor: true,
        watchOverflow: true,
        breakpoints: {
          1000: { slidesPerView: dSPV, spaceBetween: gap }
        },
        autoplay:
          autoplayOn && slideCount > 1 && !reduced.matches
            ? { delay: delay, disableOnInteraction: false, pauseOnMouseEnter: true }
            : false,
        pagination: dots ? { el: dots, clickable: true } : false,
        navigation: prev && next ? { prevEl: prev, nextEl: next } : false,
        a11y: { enabled: true },
        on: {
          // dragging to another card stops whatever was playing
          slideChangeTransitionStart: pauseAll
        }
      });
    });
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('.coreex-testimonials');
    for (var i = 0; i < nodes.length; i++) initSection(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.coreex-testimonials');
    if (r) {
      r.__ctInit = false;
      initSection(r);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target.querySelector('.coreex-testimonials');
    if (r && r.__ctSwiper) {
      r.__ctSwiper.destroy(true, true);
      r.__ctSwiper = null;
      r.__ctInit = false;
    }
  });
})();
